<template>
  <div id="gnodMap" class="p-3" v-if="exploreEntity">
    <a v-for="i in len" :key="i - 1" class="S" :id="`s${i - 1}`" @click="updateGraph(i - 1)">{{
      titles[i - 1]
    }}</a>
  </div>
</template>

<script>
import GnodMap from '../plugins/related';

export default {
  name: 'explore',

  computed: {
    exploreEntity() {
      return this.$store.state.current_selected_entity.word;
    },

    viewExploreEntity() {
      return this.$store.state.explore.entity;
    },

    knowledgeBase() {
      return this.$store.state.explore.links;
    },

    len() {
      if (this.knowledgeBase) {
        return this.knowledgeBase.length;
      }
      return 0;
    },

    titles() {
      return this.knowledgeBase.map((el) => el.title);
    },

    weights() {
      return this.knowledgeBase.map((el) => el.count);
    },
  },

  created() {
    this.$highway.singleDispatcher('fetchExploreInformation');
  },

  methods: {
    r(len) {
      const ar = [];
      let f = false;
      for (let i = 0; i < len; i++) {
        if (f) {
          ar[i] = Math.random() * 100;
          f = !f;
        } else {
          ar[i] = Math.random();
        }
      }
      return ar;
    },

    async updateGraph(index) {
      this.$store.dispatch('askWolfram', this.titles[index]);
      this.$store.dispatch('wikiWordFetch', this.titles[index]);
      this.$store.dispatch('wikiSnippet', { word: this.titles[index], type: 'word' });
      await this.$store.dispatch('fetchExploreInformation', this.titles[index]);
      if (this.exploreEntity && this.knowledgeBase) {
        this.generateGraph();
      }
    },

    generateGraph() {
      const dist = [];
      for (let i = 0; i < this.len; i++) {
        dist[i] = this.r(this.len);
      }
      dist[0] = this.knowledgeBase.map((el) => el.count).reverse();
      dist[0][0] = -1;

      let Aid = [];
      Aid = dist;

      const gnodMap = this.map;
      console.log(typeof gnodMap);
      gnodMap.left = 0;
      gnodMap.top = 0;
      gnodMap.aid = Aid;
      gnodMap.init();
    },
  },

  watch: {
    async exploreEntity() {
      await this.$store.dispatch('fetchExploreInformation', this.exploreEntity);
      if (this.exploreEntity && this.knowledgeBase) {
        this.generateGraph();
      }
    },
  },

  async mounted() {
    const gnodMap = new GnodMap();
    this.map = gnodMap;
    if (this.exploreEntity && this.knowledgeBase) {
      this.generateGraph();
    }
  },
};
</script>

<style lang="scss" scoped>
.search {
  height: 90vh;
  width: 20vw;
  background: #f5f5f5;
  &__entity {
    font-weight: bold;
  }

  &__information {
    flex: 1;
    height: 76vh;
    overflow: auto;
  }
}

#gnodMap {
  position: relative;
  box-shadow: inset 4px 4px 0px #f5f5f5;
  box-shadow: none;
  height: 80vh;
}

.S:hover {
  background-color: rgb(247, 192, 219);
  z-index: 100;
  transform: scale(1.2);
  font-weight: bold;
}

.S {
  background: #d2691e7d;
  font-size: smaller;
}

.S {
  visibility: visible;
  font-size: 0.8125rem;
  font-family: Arial, Helvetica, sans-serif;
  cursor: pointer;
  text-decoration: none;
  padding: 5px 9px;
  transition: background 0.2s linear;
  position: absolute;
}

.S:hover {
  text-decoration: none;
}

#s0 {
  font-size: large;
  background: #f75353;
  font-weight: bold;
}

#gnodMap a {
  color: #000000;
}
</style>
